/**
 * Represents the enumeration of business events to track.
 */
export enum BusinessEventEnum {

    LOGIN = 'Login'
}